import ApplicationsComponent from 'components/marketingSite/applications/ApplicationsComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type Props = {
  baseUrl: string;
};

const ApplicationsLandingPage: React.FC<Props> = ({ baseUrl }) => {
  const { t } = useI18n('applications-landing');

  usePageTrack('Website - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('applicationsLanding.page_title')}
        desc={t('applicationsLanding.page_desc')}
        url={APP_URLS.cvApplicationsLanding}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_jobapplicationslanding.png'
        )}`}
        indexable={true}
      />
      <ApplicationsComponent />
    </>
  );
};

export default ApplicationsLandingPage;

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'applications-landing'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
